const lang = document.documentElement.lang;

if (lang === 'ar') {
  const translateNewToArabic = () => {
    document.querySelectorAll(".bss-countdown-display p").forEach(el => {
      if (el.textContent.trim().toLowerCase() === "new") {
        el.textContent = "جديد";
      }
    });
  };

  
  translateNewToArabic();

  
  const observer = new MutationObserver(() => {
    translateNewToArabic();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}